<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Torre: {{ rental.tower.name }} - Unit: {{ rental.unit.number }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.rental.unit.edit', params: {id: rental.id, tower_id: rental.tower_id, unit_id: rental.unit_id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', rental)") Excluir
      .body
        .row
          .col-12
            h6.m-b-15
              span.badge.badge-default.float-right UNIDADE {{ rental.unit.number }} -&nbsp;
                i.zmdi.zmdi-circle.offline(v-if="rental.status === 'false'")
                i.zmdi.zmdi-circle.online(v-if="rental.status === 'true'")
        .row
          .col-5
            small
              strong GARAGEM:

          .col-7
            small
              strong TORRE:
        .row
          .col-5
            span.badge.float-left(
              v-for="g in rental.garage",
              :class="{'badge-success': g.id === rental.garage_id, 'badge-default': g.id !== rental.garage_id}"
              style="margin-right: 5px;"
            )
              | {{g.number}}
          .col-7
            small
              | {{ rental.tower.name}}
        .row
          .col-5
            small
              strong INQUILINO:

          .col-7
            small
              strong FONE:
        .row
          .col-5
            img.team-info.cursor-pointer(
              :src='rental.user.image.url',
              :title="rental.user.name",
              :alt='rental.user.name'
              v-if="rental.user.image !== null",
            )
            img.team-info.cursor-pointer(
              src='/static/images/profile_av.jpeg',
              :title="rental.user.name",
              :alt='rental.user.name'
              v-if="rental.user.image === null",
            )
          .col-7
            small {{ maskPhone(rental.tenant.phone) }}
            br
            small {{ rental.tenant.name }}

</template>
<style scoped>
  .team-info {
      width: 42px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      border-radius: 50%;
      border: 2px solid #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      margin-top: 0px;
  }
  .online {
    color: #86BB71;
  }
  .offline {
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/rental/index/components/item.vue